import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { getUTMData } from "./utm";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// CTA & Navigation Tracking Utilities
export interface CTATrackingData {
  cta_text: string;
  cta_location: string;
  cta_type?: string;
  cta_url?: string;
}

export interface NavTrackingData {
  nav_text: string;
  nav_location: string;
  nav_type?: string;
  nav_url?: string;
}

// Send a GA4 event via gtag (GTM dropped: GA4-direct is the single path).
const sendGA4Event = (name: string, params: Record<string, unknown>) => {
  if (typeof window === 'undefined') return;
  const gtag = (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag;
  if (typeof gtag === 'function') gtag('event', name, params);
};

export const trackCTAClick = (data: CTATrackingData) => {
  if (typeof window === 'undefined') return;
  const utmData = getUTMData();
  sendGA4Event('cta_click', {
    cta_text: data.cta_text,
    cta_location: data.cta_location,
    cta_type: data.cta_type || 'button',
    cta_url: data.cta_url || window.location.href,
    page_location: window.location.href,
    utm_source: utmData.utm_source,
    utm_medium: utmData.utm_medium,
    utm_campaign: utmData.utm_campaign,
    utm_term: utmData.utm_term,
    utm_content: utmData.utm_content,
    referrer: utmData.referrer
  });
};

export const trackNavClick = (data: NavTrackingData) => {
  if (typeof window === 'undefined') return;
  const utmData = getUTMData();
  sendGA4Event('nav_click', {
    nav_text: data.nav_text,
    nav_location: data.nav_location,
    nav_type: data.nav_type || 'navigation',
    nav_url: data.nav_url || window.location.href,
    page_location: window.location.href,
    utm_source: utmData.utm_source,
    utm_medium: utmData.utm_medium,
    utm_campaign: utmData.utm_campaign,
    utm_term: utmData.utm_term,
    utm_content: utmData.utm_content,
    referrer: utmData.referrer
  });
};
